import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f3e786e8&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\redeem-gift\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3e786e8')) {
      api.createRecord('f3e786e8', component.options)
    } else {
      api.reload('f3e786e8', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=f3e786e8&", function () {
      api.rerender('f3e786e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "RedeemGift/App.vue"
export default component.exports